export const mode = (data: number[]) => {
    const frequencyMap: {[key: number]: number} = {};
    let maxCount = 0;
    let mode = -1;

    for (const num of data) {
        frequencyMap[Number(num)] = (frequencyMap[Number(num)] ?? 0) + 1;

        if (frequencyMap[Number(num)] > maxCount) {
            maxCount = frequencyMap[Number(num)];
        }
    }

    for (const num in frequencyMap) {
        if (frequencyMap[Number(num)] == maxCount) {
            mode = Number(num);
            break;
        }
    }

    return mode;
};
